import React from 'react';
import Input from '../base/Form/Input';
import Form from '../base/Form/Form';

class DemoForm extends React.Component {
  render() {
    return (
      <div className="demo-section">
        <h1 className="text-weight-light sp-xs-bottom-2 text-accent">Forms</h1>
        <div className="row">
          <div className="col-md-4">
            <Form>
              <h4 className="text-weight-light text-muted sp-xs-bottom-2">Normal input</h4>
              <Input
                name="email"
                type="text"
                placeholder="Email"
                className="input"
                validate={['required', 'email']}
                autoComplete="off"
              />
              <Input
                name="password"
                type="text"
                placeholder="Password"
                className="input"
                validate={['required', 'password']}
                autoComplete="off"
              />
              <button className="btn btn-outline-accent fill-width sp-xs-bottom-2">Entrar</button>
            </Form>
          </div>
          <div className="col-md-4 sp-xs-top-1 sp-md-top-none">
            <h4 className="text-weight-light text-muted sp-xs-bottom-2">Input group</h4>
            <div className="form-group">
              <div className="input-group">
                <span className="input-group-addon">
                  @
                </span>
                <input type="text" className="input" defaultValue="Johndoe" placeholder="Search for..." />
                <span className="input-group-btn">
                  <button className="btn btn-outline-accent" type="button">Check</button>
                </span>
              </div>
              <span className="input-subtext">This is a subtext</span>
            </div>
          </div>
          <div className="col-md-4 sp-xs-top-1 sp-md-top-none">
            <h4 className="text-weight-light text-muted sp-xs-bottom-2">Checkbox and Radio</h4>
            <label>
              <input type="checkbox" className="input sp-xs-right-1"/>
              <span>I agree with <a href="">Terms</a></span>
            </label>
            <div className="sp-xs-top-1">
              <label className="sp-xs-right-2">
                <input name="teste" type="radio" className="input sp-xs-right-1"/>
                <span>Male</span>
              </label>
              <label>
                <input name="teste" type="radio" className="input sp-xs-right-1"/>
                <span>Female</span>
              </label>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default DemoForm;



/** WEBPACK FOOTER **
 ** ./src/components/demo/DemoForm.js
 **/